<template>
  <v-popover placement="bottom-end" offset="10">
    <LinkWIcon class="mr-2"
               :text="filtersSortByLabel">
      <template #icon>
        <IconSortBars class="text-icon mr-3 transform"
                      :class="{'-scale-y-100':filters.sort_type === ''}"/>
      </template>
    </LinkWIcon>
    <template #popover>
      <BaseRadioGroup :options="sort_by_list"
                      :value="filters.sort_by"
                      @change="setFilterByName({name:'sort_by',value:$event});$emit('filtersChanged');"/>
      <BaseRadioGroup class="border-t border-border pt-4 mt-4"
                      :options="sort_type_list"
                      :value="filters.sort_type"
                      @change="setFilterByName({name:'sort_type',value:$event});$emit('filtersChanged');"/>
    </template>
  </v-popover>
</template>

<script>
import {mapMutations, mapState} from "vuex";
import IconSortBars from "@/components/icons/IconSortBars";
import BaseRadioGroup from "@/components/UI/BaseRadioGroup";
import LinkWIcon from "@/components/UI/LinkWIcon";

export default {
  name: "TransactionsSorting",
  components: {LinkWIcon, BaseRadioGroup, IconSortBars},
  data() {
    return {
      sort_type_list: [
        {label: this.$t('sortTypeAscLabel'), value: ''},
        {label: this.$t('sortTypeDescLabel'), value: '-'},
      ],
      sort_by_list: [
        {label: this.$t('sortByDateCreationLabel'), value: 'date'},
        {label: this.$t('sortByDateEntryLabel'), value: 'created_at'},
        {label: this.$t('sortByValueLabel'), value: 'sum_base'}
      ],
    }
  },
  computed: {
    ...mapState('space/transactions', ['filters']),
    filtersSortByLabel() {
      return this.sort_by_list.find(i => i.value === this.filters.sort_by).label
    }
  },
  methods: {
    ...mapMutations('space/transactions', ['setFilterByName']),
  },
  i18n: {
    messages: {
      en: {
        sortTypeAscLabel: 'Ascending',
        sortTypeDescLabel: 'Descending',
        sortByDateCreationLabel: 'By date of operation',
        sortByDateEntryLabel: 'By date of entry',
        sortByValueLabel: 'By sum'
      },
      ru: {
        sortTypeAscLabel: 'По возрастанию',
        sortTypeDescLabel: 'По убыванию',
        sortByDateCreationLabel: 'По дате операции',
        sortByDateEntryLabel: 'По дате внесения',
        sortByValueLabel: 'По сумме'
      }
    }
  }
}
</script>

<style>
.-scale-y-100 {
  transform: scaleY(-1);
}
</style>